import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

const ObjectsMenu = React.memo(() => (
  <SideNavigation>
    <SideNavigationItem isDefault to="">
      <FormattedMessage id="map.tab.objects" defaultMessage="Objects" />
    </SideNavigationItem>
    <SideNavigationItem to="groups">
      <FormattedMessage id="objects.menu.groups" defaultMessage="Groups" />
    </SideNavigationItem>
  </SideNavigation>
));

export { ObjectsMenu };
